import { Spin } from 'antd';
import { useMemo } from 'react';

import type { AiChatLayoutProps } from '@pages/AiAgents/types';
import { AiChatInput, AiChatMessages } from '@pages/AiAgents/ui';

import type { FC } from 'react';

export const AiChatLayout: FC<AiChatLayoutProps> = ({
  messages,
  isChatLoading,
  isMessagesLoading,
  isSending,
  inputValue,
  isInputDisabled,
  onInputChange,
  onSend,
  messagesContainerRef,
  isResetting,
  onReset,
}) => {
  const isInitialLoading = useMemo(
    () => isChatLoading || (isMessagesLoading && messages.length === 0),
    [isChatLoading, isMessagesLoading, messages.length]
  );

  return (
    <div className="ai-agents-chat">
      <div className="ai-agents-chat__messages" ref={messagesContainerRef}>
        {isInitialLoading ? (
          <div className="ai-agents-chat__spinner">
            <Spin />
          </div>
        ) : (
          <AiChatMessages
            messages={messages}
            isMessagesLoading={isMessagesLoading}
          />
        )}
      </div>

      <div className="ai-agents-chat__input">
        <AiChatInput
          value={inputValue}
          disabled={isInputDisabled}
          loading={isSending}
          onChange={onInputChange}
          onSend={onSend}
          isResetting={isResetting}
          onReset={onReset}
        />
      </div>
    </div>
  );
};
